import { render, staticRenderFns } from "./CharacterClassSelect.vue?vue&type=template&id=552433fd&"
import script from "./CharacterClassSelect.vue?vue&type=script&lang=js&"
export * from "./CharacterClassSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports